import { NgModule } from '@angular/core';
import { AngularMaterialModule } from 'src/app/angular-material.module';
import { BarRatingModule } from "ngx-bar-rating";
import { CommonModule } from '@angular/common';
import { ColorPickerModule } from 'ngx-color-picker';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { MultiTranslateHttpLoader } from "ngx-translate-multi-http-loader";
import { HttpClient } from '@angular/common/http';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

/* Swiper */
import { SwiperModule } from 'ngx-swiper-wrapper';
import { SWIPER_CONFIG } from 'ngx-swiper-wrapper';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';

const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
    direction: 'horizontal',
    slidesPerView: 'auto'
};

/** Directives */
import { LazyloadDirective } from './directives/lazyLoad/lazyload.directive';

/** Pipes  */
import { DurationPipe } from './pipes//duration/duration.pipe';
import { DurationCalcPipe } from './pipes/durationCalc/duration-calc.pipe';
import { GetImagePipe } from './pipes/getImage/get-image.pipe';
import { JsonparserPipe } from './pipes/jsonparser/jsonparser.pipe';
import { MapPaymentMethodPipe } from './pipes/mapPaymentMethod/map-payment-method.pipe';
import { MomentPipe } from 'src/app/pipes/moment/moment.pipe';
import { SetupSubInfoPipe } from './pipes/setupSubInfo/setup-sub-info.pipe';

@NgModule({
    imports: [
        AngularMaterialModule,
        CommonModule,
        BarRatingModule,
        ColorPickerModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (HttpLoaderFactory),
                deps: [HttpClient]
            }
        }),
        SwiperModule
    ],
    providers: [{
        provide: SWIPER_CONFIG,
        useValue: DEFAULT_SWIPER_CONFIG
    }],
    declarations: [
        LazyloadDirective,
        DurationPipe,
        DurationCalcPipe,
        GetImagePipe,
        JsonparserPipe,
        MapPaymentMethodPipe,
        MomentPipe,
        SetupSubInfoPipe
    ],
    exports: [
        AngularMaterialModule,
        CommonModule,
        BarRatingModule,
        ColorPickerModule,
        InfiniteScrollModule,
        TranslateModule,
        SwiperModule,
        LazyloadDirective,
        DurationPipe,
        DurationCalcPipe,
        GetImagePipe,
        JsonparserPipe,
        MapPaymentMethodPipe,
        MomentPipe,
        SetupSubInfoPipe
    ]
})

export class ShareModule { }

/** Load the proper translation files */
export function HttpLoaderFactory(http: HttpClient) {
    return new MultiTranslateHttpLoader(http, [
        { prefix: "./assets/i18n/", suffix: ".json" },
        { prefix: "./assets/i18n/countries/", suffix: ".json" },
        { prefix: "./assets/i18n/languages/", suffix: ".json" }
    ]);
}